module.exports = __webpack_public_path__ + "static/img/hotel-book-price-tag.9be45617.png";